/*
 * @Description: 商品追溯查询
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-08 16:03:34
 * @LastEditTime: 2020-12-14 20:00:39
 */

import request from "_private/utils/request";

// 获取商品信息
export function fetchGoodsByTagCode(params) {
  return request({
    url: "/coldTrace/getGoodsByTagCode",
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 全流程追溯
export function fetchWholeTrace(params) {
  return request({
    url: "/coldTrace/getWholeTrace",
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 批次流通详情
export function fetchBatchTraceDetail(params) {
  return request({
    url: "/coldTrace/getBatchTraceDetail",
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 追溯详情
export function fetchTraceDetail(params) {
  return request({
    url: "/coldTrace/getTraceDetail",
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 全程轨迹
export function fetchWholeTraceTrack(params) {
  return request({
    url: "/coldTrace/getWholeTraceTrack",
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 全程温度
export function fetchWholeTraceTemperature(params) {
  return request({
    url: "/coldTrace/getWholeTraceTemperature",
    method: "get",
    headers: { type: "json" },
    params
  });
}
